import React from "react";

import { useFormContext } from "react-hook-form";

import { FormInputField } from "@components-shared/desktop/inputs";
import { useValueAvailabilityDebounce } from "@state/hooks/shared";

export default function RegistrationUsername(props: {
	checkUserNameAvailability: (data: string) => Promise<boolean>;
	labelClassName?: string;
	label?: string;
	placeholder?: string;
}) {
	const {
		formState: { errors },
		clearErrors,
	} = useFormContext();

	const { checkUserNameAvailability, labelClassName, label, placeholder } =
		props;

	const debouncer = useValueAvailabilityDebounce();

	return (
		<FormInputField
			id="userName"
			className="form__field"
			name="username"
			label={label ?? "registration:USERNAME_LABEL"}
			labelClassName={labelClassName}
			placeholder={placeholder ?? "registration:USERNAME_PLACEHOLDER"}
			pattern={{
				value: /^[a-zA-Z0-9_-]{6,20}$/,
				message: "registration:USERNAME_CHARACTERS_TW",
			}}
			validate={{
				isAvailable: async (value: string) => {
					if (errors?.["username"]) {
						clearErrors("username");
					}
					const isAvailable = await debouncer(
						value,
						checkUserNameAvailability
					);
					return isAvailable || "registration:USERNAME_NOT_AVAILABLE";
				},
			}}
			required
		/>
	);
}
